<template>
  <div class="rightBox">
    <div>
      <el-tooltip placement="left" effect="light">
        <div slot="content">
          <p>13098823590</p>
        </div>
        <div class="littleBox">
          <img src="@/assets/images/客服图标.png" alt="" />
          <p>客服电话</p>
        </div>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip placement="left" effect="light">
        <div slot="content">
          <img src="@/assets/images/公众号.jpg" alt="" class="riImg" />
        </div>
        <div class="littleBox">
          <img src="@/assets/images/微信图标.png" alt="" />
          <p>官方微信</p>
        </div>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip placement="left" effect="light">
        <div slot="content">
          <img src="@/assets/images/今日头条.jpg" alt="" class="riImg" />
        </div>
        <div class="littleBox">
          <img src="@/assets/images/头条图标.png" alt="" />
          <p>今日头条</p>
        </div>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip placement="left" effect="light">
        <div slot="content">
          <img src="@/assets/images/抖音二维码.png" alt="" class="riImg" />
        </div>
        <div class="littleBox">
          <img src="@/assets/images/抖音图标.png" alt="" />
          <p>官方抖音</p>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.rightBox {
  position: fixed;
  top: calc(50% - 80px);
  right: 0;
  z-index: 100;
  .littleBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #faf9f9;
    width: 80px;
    height: 70px;
    img {
      width: 30px;
      height: 30px;
    }
    p {
      font-size: 14px;
    }
  }
}
.riImg {
  width: 150px;
  height: 150px;
}
</style>
